import { useEffect, useSyncExternalStore } from "react";

// How many properties panels are open with Apply and Cancel showing. A panel's own
// actions confirm or abandon its edits, so the page's actions would compete with them.
let open = 0;
const listeners = new Set<() => void>();

const change = (by: number) => {
  open += by;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

/** Marks a properties panel as open for as long as `active` holds. */
export function useRegisterPropertiesEditing(active: boolean) {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    change(1);

    return () => change(-1);
  }, [active]);
}

/** Whether a properties panel is open, so the page can hold back its own actions. */
export const useIsEditingProperties = () =>
  useSyncExternalStore(
    subscribe,
    () => open > 0,
    () => false
  );
